import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import ManageTasksForm from './form'

const ManageTasksDialog = React.forwardRef(function ManageTasksDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (entry) => setDialogState({ open: true, processing: false, entry })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Manage Tasks'
      open={dialogState.open}
      onClose={close}
      position='top'
      size='medium'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<ManageTasksForm entry={dialogState.entry} onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

ManageTasksDialog.propTypes = {
  onComplete: PropTypes.func
}

ManageTasksDialog.defaultProps = {
  onComplete: () => {}
}

export default ManageTasksDialog
